import React, { useMemo, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  AppBar,
  Tabs,
  Tab,
  Button,
  Typography,
  Badge,
} from '@material-ui/core';
// import { parseISO, format } from 'date-fns';

import AirportShuttle from '@material-ui/icons/AirportShuttle';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import EventSeat from '@material-ui/icons/EventSeat';
import LaptopChromebook from '@material-ui/icons/LaptopChromebook';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import PersonIcon from '@material-ui/icons/Person';
import RvHookup from '@material-ui/icons/RvHookup';
import { format, parseISO, subDays } from 'date-fns';
import { isArray } from 'lodash';

import { UnidataTable } from '~/components';
import CustomizedDialogs from '~/componentsLocal/UnidataDialog';
import { t, canURL, number } from '~/helpers';
import api from '~/services/api';
import { recordFiltering as recordFilteringEntradaComboio } from '~/store/modules/raizenerrologintegracaoentradacomboio/actions';
import { recordFiltering as recordFilteringMovimentacaoComboio } from '~/store/modules/raizenerrologintegracaomovimentacaocomboio/actions';
import { recordFiltering as recordFilteringMovimentacaoPosto } from '~/store/modules/raizenerrologintegracaomovimentacaoposto/actions';
import { recordFiltering as recordFilteringTransferencia } from '~/store/modules/raizenerrologintegracaotransferencia/actions';

import TabelaMovimentacao from './components/TabelaMovimentacao';

function Raizenerrologintegracao() {
  const dispatch = useDispatch();

  const [value, setValue] = useState(0);
  const [selected, setSelected] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [openModalCancelado, setOpenModalCancelado] = useState(false);

  const [stateOpenModal, setStateOpenModal] = useState(false);
  const [stateOpenModallCancelado, setStateOpenModallCancelado] = useState(
    false
  );

  const [janelaAberta, setJanelaAberta] = React.useState(false);

  const [habUpdte, setHabUpdte] = React.useState(false);

  const reduxEntradaComboio = useSelector(
    (state) => state.raizenerrologintegracaoentradacomboio
  );
  const reduxMovimentacaoComboio = useSelector(
    (state) => state.raizenerrologintegracaomovimentacaocomboio
  );
  const reduxMovimentacaoPosto = useSelector(
    (state) => state.raizenerrologintegracaomovimentacaoposto
  );
  const reduxTransferencia = useSelector(
    (state) => state.raizenerrologintegracaotransferencia
  );

  const status = useMemo(
    () => [
      { label: 'N', value: t('s.geral.opcoes.naoenviado') },
      { label: 'S', value: t('s.geral.opcoes.liberadoenvio') },
      // { label: 'E', value: t('s.geral.opcoes.enviado') },
      { label: 'P', value: t('s.geral.opcoes.pendente') },
    ],
    []
  );

  // const isDisabled = useMemo(() => {
  //   return (
  //     !selected ||
  //     Object.keys(selected).length === 0 ||
  //     selected.statuscorrecaoraizenerrologintegracao !== 0 ||
  //     (selected.gerainterfaceraizenerrologintegracao !== 'N' &&
  //       selected.gerainterfaceraizenerrologintegracao !== 'P')
  //     // selected.gerainterfaceraizenerrologintegracao !== 'N'
  //   );
  // }, [selected]);
  const isDisabled = useMemo(() => {
    if (!selected || Object.keys(selected).length === 0) {
      return true;
    }

    if (selected.gerainterfaceraizenerrologintegracao === 'N') {
      if (!habUpdte) {
        // bloqueia
        return true;
      }

      return selected.statuscorrecaoraizenerrologintegracao !== 0;
    }

    if (selected.gerainterfaceraizenerrologintegracao === 'P') {
      if (!habUpdte) {
        // bloqueia
        return true;
      }

      return false; // libera o botão
    }

    return true; // qualquer outro valor bloqueia
  }, [selected, habUpdte]);

  const header = useMemo(
    () => [
      {
        id: 'codigonomeposto',
        label: t('s.operacao.abastecimento.nomeposto'),
      },
      {
        id: 'idveiculo',
        label: t('s.operacao.abastecimento.idveiculo'),
      },
      {
        id: 'volumemovimentacao',
        label: t('s.operacao.abastecimento.volumemovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.abastecimento.nomeproduto'),
      },
      {
        id: 'idbico',
        label: t('s.operacao.abastecimento.idbico'),
      },
      {
        id: 'datahorainicialmovimentacao',
        label: t('s.operacao.abastecimento.datahorainicialmovimentacao'),
        align: 'left',
        format: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        // format: (value) => dataHora(value),
      },
      {
        id: 'datahorafinalmovimentacao',
        label: t('s.operacao.abastecimento.datahorafinalmovimentacao'),
        align: 'left',
        format: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        // format: (value) => hora(value),
      },
      {
        id: 'encerranteinicialmovimentacao',
        label: t('s.geral.camposistema.encerranteinicialmovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'encerrantefinalmovimentacao',
        label: t('s.geral.camposistema.encerrantefinalmovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      },
    ],
    []
  );

  const headerComboioTransferencia = useMemo(() => {
    const data = [
      {
        id: 'datahorainicialmovimentacao',
        label: t('s.operacao.transferencia.datahorainicialmovimentacao'),
        format: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'datahorafinalmovimentacao',
        label: t('s.operacao.transferencia.datahorafinalmovimentacao'),
        format: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'codigonomeposto',
        label: t('s.geral.pontoorigem'),
      },
      {
        id: 'idbico',
        label: t('s.operacao.transferencia.idbico'),
        align: 'left',
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.transferencia.nomeproduto'),
      },
      {
        id: 'codigonomepostodestino',
        label: t('s.geral.pontodestino'),
      },
      {
        id: 'codigousuario',
        label: t('s.operacao.transferencia.codigousuario'),
        align: 'left',
      },
      {
        id: 'encerrantemovimentacaotransferencia',
        label: t('s.relatorio.vazaonaoautorizadalistagem.encerrante'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'volumemovimentacao',
        label: t('s.operacao.transferencia.volumemovimentacao'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
    ];

    return data;
  }, []);

  const headerEntradaComboio = useMemo(
    () => [
      // {
      //   id: 'idraizenerrologintegracao',
      //   label: t('ID'),
      // },
      {
        id: 'datahorainiciologeventoraizenerrologintegracao',
        label: t('s.operacao.abastecimento.datahorainicialmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'initialdatetime',
          defaultValue: format(
            subDays(new Date().setHours(0, 0, 0, 0), 30),
            'dd/MM/yyyy HH:mm:ss'
          ),
        },
      },
      {
        id: 'datahorafimlogeventoraizenerrologintegracao',
        label: t('s.operacao.abastecimento.datahorafinalmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'finaldatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.geral.pontoorigem'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idbico',
        label: t('s.operacao.transferencia.idbico'),
        filter: {
          type: 'number',
        },
        align: 'left',
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.transferencia.nomeproduto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigonomepostodestino',
        label: t('s.geral.pontodestino'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigousuario',
        label: t('s.operacao.transferencia.codigousuario'),
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'encerrantemovimentacaotransferencia',
        label: t('s.relatorio.vazaonaoautorizadalistagem.encerrante'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'volumemovimentacao',
        label: t('s.operacao.transferencia.volumemovimentacao'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'datahorainicialmovimentacao',
        label: t(
          's.operacao.raizenerrologintegracao.datahorainicialmovimentacaoregistro'
        ),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'gerainterfaceraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.gerainterfaceraizenerrologintegracao'
        ),
        styled: (row) => {
          if (row.gerainterfaceraizenerrologintegracao === 'S') {
            return { color: '#155724', fontWeight: 'bold' }; // verde
          }
          if (row.gerainterfaceraizenerrologintegracao === 'P') {
            return { color: '#721c24', fontWeight: 'bold' }; // vermelho
          }
          return { color: '#856404', fontWeight: 'normal' }; // amarelo
        },
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
        onUpdate: (row) => {
          alert(
            `Você clicou para atualizar ${row.gerainterfaceraizenerrologintegracaostr}`
          );
        },
      },
      {
        id: 'erroraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.erroraizenerrologintegracao'
        ),
      },
      {
        id: 'statuserroenvioraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.statuserroenvioraizenerrologintegracao'
        ),
      },
    ],
    []
  );

  const headerMovimentacaoComboio = useMemo(
    () => [
      {
        id: 'datahorainiciologeventoraizenerrologintegracao',
        label: t('s.operacao.abastecimento.datahorainicialmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'initialdatetime',
          defaultValue: format(
            subDays(new Date().setHours(0, 0, 0, 0), 30),
            'dd/MM/yyyy HH:mm:ss'
          ),
        },
      },
      {
        id: 'datahorafimlogeventoraizenerrologintegracao',
        label: t('s.operacao.abastecimento.datahorafinalmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'finaldatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.operacao.abastecimento.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'idbico',
        label: t('s.operacao.abastecimento.idbico'),
        filter: { type: 'number' },
        align: 'left',
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.abastecimento.nomeproduto'),
        filter: { type: 'text' },
      },
      {
        id: 'idveiculo',
        label: t('s.operacao.abastecimento.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'volumemovimentacao',
        label: t('s.operacao.abastecimento.volumemovimentacao'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'datahorainicialmovimentacao',
        label: t(
          's.operacao.raizenerrologintegracao.datahorainicialmovimentacaoregistro'
        ),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'gerainterfaceraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.gerainterfaceraizenerrologintegracao'
        ),
        styled: (row) => {
          if (row.gerainterfaceraizenerrologintegracao === 'S') {
            return { color: '#155724', fontWeight: 'bold' }; // verde
          }
          if (row.gerainterfaceraizenerrologintegracao === 'P') {
            return { color: '#721c24', fontWeight: 'bold' }; // vermelho
          }
          return { color: '#856404', fontWeight: 'normal' }; // amarelo
        },
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
        // styled: (row) => {
        //   if (row.gerainterfaceraizenerrologintegracao === 'S') {
        //     return { backgroundColor: '#d4edda', color: '#155724' }; // verde
        //   }
        //   if (row.gerainterfaceraizenerrologintegracao === 'P') {
        //     return { backgroundColor: '#f8d7da', color: '#721c24' }; // vermelho
        //   }
        //   return { backgroundColor: '#fff3cd', color: '#856404' }; // amarelo
        // },
      },
      {
        id: 'erroraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.erroraizenerrologintegracao'
        ),
      },

      {
        id: 'statuserroenvioraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.statuserroenvioraizenerrologintegracao'
        ),
      },
    ],
    []
  );

  const headerMovimentacaoPosto = useMemo(
    () => [
      {
        id: 'datahorainiciologeventoraizenerrologintegracao',
        label: t('s.operacao.abastecimento.datahorainicialmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'initialdatetime',
          defaultValue: format(
            subDays(new Date().setHours(0, 0, 0, 0), 30),
            'dd/MM/yyyy HH:mm:ss'
          ),
        },
      },
      {
        id: 'datahorafimlogeventoraizenerrologintegracao',
        label: t('s.operacao.abastecimento.datahorafinalmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'finaldatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.operacao.abastecimento.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'idbico',
        label: t('s.operacao.abastecimento.idbico'),
        filter: { type: 'number' },
        align: 'left',
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.abastecimento.nomeproduto'),
        filter: { type: 'text' },
      },
      {
        id: 'idveiculo',
        label: t('s.operacao.abastecimento.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'volumemovimentacao',
        label: t('s.operacao.abastecimento.volumemovimentacao'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'datahorainicialmovimentacao',
        label: t(
          's.operacao.raizenerrologintegracao.datahorainicialmovimentacaoregistro'
        ),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'gerainterfaceraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.gerainterfaceraizenerrologintegracao'
        ),
        styled: (row) => {
          if (row.gerainterfaceraizenerrologintegracao === 'S') {
            return { color: '#155724', fontWeight: 'bold' }; // verde
          }
          if (row.gerainterfaceraizenerrologintegracao === 'P') {
            return { color: '#721c24', fontWeight: 'bold' }; // vermelho
          }
          return { color: '#856404', fontWeight: 'normal' }; // amarelo
        },
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
      {
        id: 'erroraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.erroraizenerrologintegracao'
        ),
      },

      {
        id: 'statuserroenvioraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.statuserroenvioraizenerrologintegracao'
        ),
      },
    ],
    []
  );
  const headerTransferencia = useMemo(
    () => [
      {
        id: 'datahorainiciologeventoraizenerrologintegracao',
        label: t('s.operacao.abastecimento.datahorainicialmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'initialdatetime',
          defaultValue: format(
            subDays(new Date().setHours(0, 0, 0, 0), 30),
            'dd/MM/yyyy HH:mm:ss'
          ),
        },
      },
      {
        id: 'datahorafimlogeventoraizenerrologintegracao',
        label: t('s.operacao.abastecimento.datahorafinalmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'finaldatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.geral.pontoorigem'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idbico',
        label: t('s.operacao.transferencia.idbico'),
        filter: {
          type: 'number',
        },
        align: 'left',
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.transferencia.nomeproduto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigonomepostodestino',
        label: t('s.geral.pontodestino'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigousuario',
        label: t('s.operacao.transferencia.codigousuario'),
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'encerrantemovimentacaotransferencia',
        label: t('s.relatorio.vazaonaoautorizadalistagem.encerrante'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'volumemovimentacao',
        label: t('s.operacao.transferencia.volumemovimentacao'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'datahorainicialmovimentacao',
        label: t(
          's.operacao.raizenerrologintegracao.datahorainicialmovimentacaoregistro'
        ),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'gerainterfaceraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.gerainterfaceraizenerrologintegracao'
        ),
        // id: 'gerainterfaceraizenerrologintegracaostr',
        // label: t('s.operacao.raizenerrologintegracao.gerainterfaceraizenerrologintegracaostr'),
        styled: (row) => {
          if (row.gerainterfaceraizenerrologintegracao === 'S') {
            return { color: '#155724', fontWeight: 'bold' }; // verde
          }
          if (row.gerainterfaceraizenerrologintegracao === 'P') {
            return { color: '#721c24', fontWeight: 'bold' }; // vermelho
          }
          return { color: '#856404', fontWeight: 'normal' }; // amarelo
        },
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
      {
        id: 'erroraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.erroraizenerrologintegracao'
        ),
      },
      {
        id: 'statuserroenvioraizenerrologintegracao',
        label: t(
          's.operacao.raizenerrologintegracao.statuserroenvioraizenerrologintegracao'
        ),
      },
    ],
    []
  );

  const endpointObjectIntegracao = {
    0: {
      url: 'raizenerrologintegracao/raizenerrologintegracaoentradacomboio',
      msg: 'raizenerrologintegracaoentradacomboio',
      label: 'tabelaraizenerrologintegracao',
    },
    1: {
      url: 'raizenerrologintegracao/raizenerrologintegracaomovimentacaocomboio',
      msg: 'raizenerrologintegracaomovimentacaocomboio',
      label: 'tabelaraizenerrologintegracao',
    },
    2: {
      url: 'raizenerrologintegracao/raizenerrologintegracaomovimentacaoposto',
      msg: 'raizenerrologintegracaomovimentacaoposto',
      label: 'tabelaraizenerrologintegracao',
    },
    3: {
      url: 'raizenerrologintegracao/raizenerrologintegracaotransferencia',
      msg: 'raizenerrologintegracaotransferencia',
      label: 'tabelaraizenerrologintegracao',
    },
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelected({});
    setStateOpenModal(false);
    setStateOpenModallCancelado(false);
    setJanelaAberta(false);
  };

  const handleModal = () => {
    if (!openModal) {
      setJanelaAberta(true);
    } else {
      setJanelaAberta(false);
    }

    setOpenModal((prevState) => !prevState);
  };

  const handleModalCancelado = () => {
    if (!openModal) {
      setJanelaAberta(true);
    } else {
      setJanelaAberta(false);
    }

    setOpenModalCancelado((prevState) => !prevState);
  };

  const handleConfirmaDesbloqueioRaizenErroLogIntegracao = async () => {
    try {
      if (value === 0)
        await api.put(
          `raizenerrologintegracao/corrigido?idraizenerrologintegracao=${selected.idraizenerrologintegracao}`
        );
      if (value === 1)
        await api.put(
          `raizenerrologintegracao/corrigido?idraizenerrologintegracao=${selected.idraizenerrologintegracao}`
        );
      if (value === 2)
        await api.put(
          `raizenerrologintegracao/corrigido?idraizenerrologintegracao=${selected.idraizenerrologintegracao}`
        );
      if (value === 3)
        await api.put(
          `raizenerrologintegracao/corrigido?idraizenerrologintegracao=${selected.idraizenerrologintegracao}`
        );

      toast.success(t('Registro liberado para envio com sucesso'));
      dispatch(recordFilteringEntradaComboio(reduxEntradaComboio.params));
      dispatch(
        recordFilteringMovimentacaoComboio(reduxMovimentacaoComboio.params)
      );
      dispatch(recordFilteringMovimentacaoPosto(reduxMovimentacaoPosto.params));
      dispatch(recordFilteringTransferencia(reduxTransferencia.params));

      await handleModal();

      setStateOpenModal(true);
    } catch (errors) {
      if (isArray(errors)) errors.map((error) => toast.error(t(error)));
      else toast.error(t(errors));
    }
  };

  const handleConfirmaCancelarRaizenErroLogIntegracao = async () => {
    try {
      if (value === 0)
        await api.put(
          `raizenerrologintegracao/cancelado?idraizenerrologintegracao=${selected.idraizenerrologintegracao}`
        );
      if (value === 1)
        await api.put(
          `raizenerrologintegracao/cancelado?idraizenerrologintegracao=${selected.idraizenerrologintegracao}`
        );
      if (value === 2)
        await api.put(
          `raizenerrologintegracao/cancelado?idraizenerrologintegracao=${selected.idraizenerrologintegracao}`
        );
      if (value === 3)
        await api.put(
          `raizenerrologintegracao/cancelado?idraizenerrologintegracao=${selected.idraizenerrologintegracao}`
        );

      toast.success(t('Registro liberado para envio com sucesso'));
      dispatch(recordFilteringEntradaComboio(reduxEntradaComboio.params));
      dispatch(
        recordFilteringMovimentacaoComboio(reduxMovimentacaoComboio.params)
      );
      dispatch(recordFilteringMovimentacaoPosto(reduxMovimentacaoPosto.params));
      dispatch(recordFilteringTransferencia(reduxTransferencia.params));

      await handleModalCancelado();

      setStateOpenModallCancelado(true);
    } catch (errors) {
      if (isArray(errors)) errors.map((error) => toast.error(t(error)));
      else toast.error(t(errors));
    }
  };

  useEffect(() => {
    setHabUpdte(canURL().update);
  }, []);

  useEffect(() => {
    if (stateOpenModal) {
      setSelected({});
    }

    if (stateOpenModallCancelado) {
      setSelected({});
    }
  }, [stateOpenModal, stateOpenModallCancelado]);

  useEffect(() => {
    const isTime = setInterval(() => {
      if (!janelaAberta) {
        dispatch(recordFilteringEntradaComboio(reduxEntradaComboio.params));
        dispatch(
          recordFilteringMovimentacaoComboio(reduxMovimentacaoComboio.params)
        );
        dispatch(
          recordFilteringMovimentacaoPosto(reduxMovimentacaoPosto.params)
        );
        dispatch(recordFilteringTransferencia(reduxTransferencia.params));
      }
    }, 60000);

    return () => clearInterval(isTime);
  }, [
    janelaAberta,
    reduxEntradaComboio,
    reduxMovimentacaoComboio,
    reduxMovimentacaoPosto,
    reduxTransferencia,
  ]);

  return (
    <>
      <AppBar position="static" color="default">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingRight: '10px',
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="off"
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab
              label="Entrada Comboio"
              icon={
                <Badge
                  badgeContent={reduxEntradaComboio.totalCount}
                  color="secondary"
                >
                  <EventSeat />
                </Badge>
              }
            />
            <Tab
              label="Movimentação Comboio"
              icon={
                <Badge
                  badgeContent={reduxMovimentacaoComboio.totalCount}
                  color="secondary"
                >
                  <DriveEtaIcon />
                </Badge>
              }
            />
            <Tab
              label="Movimentação Posto"
              icon={
                <Badge
                  badgeContent={reduxMovimentacaoPosto.totalCount}
                  color="secondary"
                >
                  <LocalGasStationIcon />
                </Badge>
              }
            />
            <Tab
              label="Transferência"
              icon={
                <Badge
                  badgeContent={reduxTransferencia.totalCount}
                  color="secondary"
                >
                  <RvHookup />
                </Badge>
              }
            />
          </Tabs>
          <div>
            <Button
              variant="contained"
              color="primary"
              disabled={isDisabled}
              // disabled={
              //   !selected ||
              //   Object.keys(selected).length === 0 ||
              //   selected.statuscorrecaoraizenerrologintegracao !== 0
              // }

              // disabled={Object.keys(selected).length === 0}
              onClick={handleModal}
              style={{ marginRight: 8 }}
            >
              Marcar como Corrigido
            </Button>
            <Button
              variant="contained"
              color="secondary"
              disabled={isDisabled}
              // disabled={
              //   !selected ||
              //   Object.keys(selected).length === 0 ||
              //   selected.statuscorrecaoraizenerrologintegracao !== 0
              // }

              // disabled={Object.keys(selected).length === 0}
              onClick={handleModalCancelado}
            >
              Marcar como Cancelado
            </Button>
          </div>
        </div>

        <div role="tabpanel" hidden={value !== 0}>
          <UnidataTable
            update={false}
            id={0}
            fixed
            redux={reduxEntradaComboio}
            header={headerEntradaComboio}
            read={recordFilteringEntradaComboio}
            keys="idraizenerrologintegracao"
            detach="idraizenerrologintegracao"
            // queryParams={{
            //   wherefield: 'statusdbic4bico',
            //   valuewherefield: 0,
            //   typewherefield: 'EQUALS',
            // }}
            onRow={(value) => setSelected(value)}
          />
        </div>
        <div role="tabpanel" hidden={value !== 1}>
          <UnidataTable
            update={false}
            id={0}
            fixed
            redux={reduxMovimentacaoComboio}
            header={headerMovimentacaoComboio}
            read={recordFilteringMovimentacaoComboio}
            keys="idraizenerrologintegracao"
            detach="idraizenerrologintegracao"
            // queryParams={{
            //   wherefield: 'statusdbic4veiculo',
            //   valuewherefield: 0,
            //   typewherefield: 'EQUALS',
            // }}
            onRow={(value) => setSelected(value)}
          />
        </div>
        <div role="tabpanel" hidden={value !== 2}>
          <UnidataTable
            update={false}
            id={2}
            fixed
            redux={reduxMovimentacaoPosto}
            header={headerMovimentacaoPosto}
            read={recordFilteringMovimentacaoPosto}
            keys="idraizenerrologintegracao"
            detach="idraizenerrologintegracao"
            // queryParams={{
            //   wherefield: 'statusdbic4usuariooperador',
            //   valuewherefield: 0,
            //   typewherefield: 'EQUALS',
            // }}
            onRow={(value) => setSelected(value)}
          />
        </div>
        <div role="tabpanel" hidden={value !== 3}>
          <UnidataTable
            update={false}
            id={3}
            fixed
            redux={reduxTransferencia}
            header={headerTransferencia}
            read={recordFilteringTransferencia}
            keys="idraizenerrologintegracao"
            detach="idraizenerrologintegracao"
            // queryParams={{
            //   wherefield: 'statusdbic4usuariooperador',
            //   valuewherefield: 0,
            //   typewherefield: 'EQUALS',
            // }}
            onRow={(value) => setSelected(value)}
          />
        </div>
      </AppBar>
      {/* <CustomizedDialogs
        open={openModal}
        handleClose={handleModal}
        children={
          <>
            {selected || Object.keys(selected).length !== 0 ?
              <>
                <Typography>
                  Deseja marcar como corrigido a {selected[endpointObjectIntegracao[value].label]}?
                </Typography>


                <TabelaMovimentacao
                  title="" // apresenta apenas o titulo da janela
                  // cells={header}
                  cells={
                    ((selected[endpointObjectIntegracao[value].label] === 'EntradaComboio') ||
                      (selected[endpointObjectIntegracao[value].label] === 'Transferencia'))
                      ? headerComboioTransferencia : header}
                  data={[selected]}
                  height="80vh"
                  size="small"
                //onIconClick={handleSelecionaMovimentacao}
                />
              </>
              :
              <>
                < Typography >
                  Deseja corrigido ?
                </Typography >
              </>
            }
          </>
          // <Typography>
          //   {JSON.stringify(selected)}
          //   Deseja marcar como corrigido o {endpointObjectIntegracao[value].msg}{' '}
          //   {selected[endpointObjectIntegracao[value].label]}?
          // </Typography>
        }
        actions={
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleConfirmaDesbloqueioRaizenErroLogIntegracao();
              }}
            >
              Sim
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                handleModal();
              }}
            >
              Não
            </Button>
          </>
        }
      /> */}

      <CustomizedDialogs
        open={openModal}
        handleClose={handleModal}
        children={
          <>
            {selected && Object.keys(selected || {}).length > 0 ? (
              <>
                <Typography>
                  Deseja marcar como corrigido a{' '}
                  {selected[endpointObjectIntegracao[value].label]}?
                </Typography>

                <TabelaMovimentacao
                  title="" // apresenta apenas o titulo da janela
                  cells={
                    selected[endpointObjectIntegracao[value].label] ===
                      'EntradaComboio' ||
                    selected[endpointObjectIntegracao[value].label] ===
                      'Transferencia'
                      ? headerComboioTransferencia
                      : header
                  }
                  data={[selected]}
                  height="80vh"
                  size="small"
                  // onIconClick={handleSelecionaMovimentacao}
                />
              </>
            ) : (
              <Typography>Deseja corrigido ?</Typography>
            )}
          </>
        }
        actions={
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleConfirmaDesbloqueioRaizenErroLogIntegracao();
              }}
            >
              Sim
            </Button>
            <Button variant="contained" color="secondary" onClick={handleModal}>
              Não
            </Button>
          </>
        }
      />

      <CustomizedDialogs
        open={openModalCancelado}
        handleClose={handleModal}
        children={
          <>
            {selected && Object.keys(selected || {}).length > 0 ? (
              <>
                <Typography>
                  Deseja cancelar a{' '}
                  {selected[endpointObjectIntegracao[value].label]}?
                </Typography>
                <TabelaMovimentacao
                  title="" // apresenta apenas o titulo da janela
                  cells={
                    selected[endpointObjectIntegracao[value].label] ===
                      'EntradaComboio' ||
                    selected[endpointObjectIntegracao[value].label] ===
                      'Transferencia'
                      ? headerComboioTransferencia
                      : header
                  }
                  data={[selected]}
                  height="80vh"
                  size="small"
                  // onIconClick={handleSelecionaMovimentacao}
                />
              </>
            ) : (
              <Typography>Deseja cancelar ?</Typography>
            )}
          </>
          // <>
          //   {selected || Object.keys(selected).length !== 0 ?
          //     <>
          //       < Typography >
          //         Deseja cancelar a {selected[endpointObjectIntegracao[value].label]}?
          //       </Typography >
          //       <TabelaMovimentacao
          //         title="" // apresenta apenas o titulo da janela
          //         cells={
          //           ((selected[endpointObjectIntegracao[value].label] === 'EntradaComboio') ||
          //             (selected[endpointObjectIntegracao[value].label] === 'Transferencia'))
          //             ? headerComboioTransferencia : header}
          //         data={[selected]}
          //         height="80vh"
          //         size="small"
          //       //onIconClick={handleSelecionaMovimentacao}
          //       />
          //     </>
          //     :
          //     <>
          //       < Typography >
          //         Deseja cancelar ?
          //       </Typography >
          //     </>
          //   }
          // </>
        }
        actions={
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleConfirmaCancelarRaizenErroLogIntegracao();
              }}
            >
              Sim
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                handleModalCancelado();
              }}
            >
              Não
            </Button>
          </>
        }
      />
    </>
  );
}

export default Raizenerrologintegracao;
